import React from 'react';

/**
 * Statistics display card
 * Used to show key metrics like years of experience, shows performed, etc.
 */
const StatCard = ({
  value,
  label,
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-center flex-1 ${className}`}>
      <span className="text-2xl font-bold text-white">{value}</span>
      <span className="text-[10px] text-gray-300 uppercase tracking-wider font-semibold">
        {label}
      </span>
    </div>
  );
};

export default StatCard;
